import { render } from "./main-pagination.vue?vue&type=template&id=fa1d9802"
import script from "./main-pagination.vue?vue&type=script&lang=js"
export * from "./main-pagination.vue?vue&type=script&lang=js"

import "./main-pagination.vue?vue&type=style&index=0&id=fa1d9802&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__